import { useQuery } from '@tanstack/vue-query';
import axios from 'axios';

export const useUserIntegrations = () => useQuery({
    queryKey: ['user-integrations'],
    queryFn: () => axios('api/Integration/ListUserIntegrations').then(res => res.data),
})